import {
  sensorAuthorizationsSucceed,
  createSensorAuthorizationSucceed,
  updateSensorAuthorizationSucceed,
  deleteSensorAuthorizationSucceed
} from '../actions';
import {
  getSensorAuthorizations as getSensorAuthorizationsApi,
  createSensorAuthorization as createSensorAuthorizationAPI,
  updateSensorAuthorization as updateSensorAuthorizationAPI,
  deleteSensorAuthorization as deleteSensorAuthorizationAPI
} from 'common/services/sensors.service';

/* istanbul ignore next */
export const getSensorAuthorizations =
  ({ withGitStreamEnabled = false, add_pr_stats = false } = {}) =>
  async dispatch => {
    try {
      const sensorAuthorizations = await getSensorAuthorizationsApi({
        withProfile: true,
        withGitStreamEnabled,
        add_pr_stats // for stats indication in Line Chart on Git-Integrations
      });
      dispatch(sensorAuthorizationsSucceed(sensorAuthorizations));
      return sensorAuthorizations;
    } catch (e) {
      return [];
    }
  };

export const createSensorAuthorization = (payload, qs) => async dispatch => {
  try {
    const sensorAuthorization = await createSensorAuthorizationAPI(payload, qs);
    dispatch(createSensorAuthorizationSucceed(sensorAuthorization));
    return sensorAuthorization;
  } catch (e) {}
};

export const updateSensorAuthorization = (id, params) => async dispatch => {
  try {
    const [sensor] = await updateSensorAuthorizationAPI(id, params);
    dispatch(updateSensorAuthorizationSucceed(sensor));
    return sensor;
  } catch (e) {}
};

export const deleteSensorAuthorization = (id, params) => async dispatch => {
  try {
    await deleteSensorAuthorizationAPI(id, params);
    dispatch(deleteSensorAuthorizationSucceed(id));
  } catch (e) {}
};
